export default {
  'RequestStatusBarSelector.pending': { en: 'Pending', fr: 'En attente' },
  'RequestStatusBarSelector.accepted': { en: 'Accepted', fr: 'Accepté' },
  'RequestStatusBarSelector.past': { en: 'Past', fr: 'Passé' },
};
